import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { DiscountControlTypeDto } from "./DiscountControlTypesDto.model";
import { GeneralDiscountCatalogDto } from "./GeneralDiscountCatalogDto.model";

export class DiscountAssociationsControlTypesDto {
    discountAssociatedControlTypePkDto?: {
        generalDiscountCatalogId?: number,
        discountControlTypeId: number
    };
    generalDiscountCatalogDto?: GeneralDiscountCatalogDto;
    discountControlTypeDto?: DiscountControlTypeDto;

    constructor(data?: Partial<DiscountAssociationsControlTypesDto>) {
        Object.assign(this, data);
    }
}

export class DiscountAssociationsControlTypesResponse {
    DiscountControlTypesDto: DiscountAssociationsControlTypesDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class DiscountAssociationsControlTypesRequest {
    DiscountControlTypesDto: DiscountAssociationsControlTypesDto = new DiscountAssociationsControlTypesDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}